import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import axios from "axios";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import qrcode from "qrcode-js";
import { Button, Row, Col, Table, Input, Label, Badge, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

// Recepcion fisica de contenedores (documento del 23 OCT 2026, pasos 16-21).
// Bodega abre el folio desde el embarque, captura piezas (una o varias veces),
// arma tarimas con LPN y termina; Auditoria da conformidad o diferencias;
// Bodega cierra y en ese momento se libera el inventario y sale ARRIBOS.
const COLOR_ESTADO = {
  Abierta: "primary",
  "En auditoria": "warning",
  "Con diferencias": "danger",
  Auditada: "info",
  Cerrada: "success",
  Cerrando: "secondary",
  "Error al cerrar": "danger",
};

function Recepciones() {
  const { user } = useContext(AuthContext);
  const URL = process.env.REACT_APP_URL_RECEPCIONES;
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  const [folios, setFolios] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState("");
  const [rec, setRec] = useState(null); // folio abierto en pantalla
  const [captura, setCaptura] = useState({}); // { renglonId: { recibidas, danadas } }
  const [trabajando, setTrabajando] = useState(false);
  // nueva recepcion
  const [modalNueva, setModalNueva] = useState(false);
  const [embarques, setEmbarques] = useState([]);
  const [embElegido, setEmbElegido] = useState("");
  // tarimas
  const [renglonTar, setRenglonTar] = useState(null);
  const [porTarima, setPorTarima] = useState("");
  const [nuevasTar, setNuevasTar] = useState([]);
  // buscar LPN
  const [lpnBuscar, setLpnBuscar] = useState("");

  const puedeCapturar = user.recepciones && rec && ["Abierta", "Con diferencias"].includes(rec.estado);
  const err = (e, t) => Swal.fire({ icon: "error", title: t, text: e.response?.data?.message || e.message });

  function cargaFolios() {
    axios
      .get(`${URL}${filtroEstado ? `?estado=${encodeURIComponent(filtroEstado)}` : ""}`, { headers })
      .then((r) => setFolios(r.data || []))
      .catch(() => setFolios([]));
  }
  useEffect(cargaFolios, [filtroEstado]); // eslint-disable-line react-hooks/exhaustive-deps

  function abre(id) {
    axios
      .get(`${URL}/${id}`, { headers })
      .then((r) => {
        setRec(r.data);
        setCaptura({});
      })
      .catch((e) => err(e, "No se pudo abrir el folio"));
  }

  function aplica(data, mensaje) {
    setRec(data);
    setCaptura({});
    cargaFolios();
    if (mensaje) Swal.fire({ icon: "success", title: mensaje, timer: 1600, showConfirmButton: false });
  }

  function nueva() {
    setEmbElegido("");
    axios
      .get(`${URL}Embarques`, { headers })
      .then((r) => {
        setEmbarques(r.data || []);
        setModalNueva(true);
      })
      .catch((e) => err(e, "No se pudieron leer los embarques"));
  }

  function creaFolio() {
    if (!embElegido) return;
    setTrabajando(true);
    axios
      .post(URL, { embarques: embElegido }, { headers })
      .then((r) => {
        setModalNueva(false);
        aplica(r.data, `Folio ${r.data.idRecepcion} abierto`);
      })
      .catch((e) => err(e, "No se pudo abrir el folio"))
      .finally(() => setTrabajando(false));
  }

  function guardaCaptura() {
    const renglones = Object.entries(captura)
      .map(([id, v]) => ({ _id: id, recibidas: Number(v.recibidas) || 0, danadas: Number(v.danadas) || 0 }))
      .filter((x) => x.recibidas || x.danadas);
    if (!renglones.length) {
      Swal.fire({ icon: "info", title: "No capturaste piezas" });
      return;
    }
    setTrabajando(true);
    axios
      .patch(`${URL}Captura/${rec._id}`, { renglones }, { headers })
      .then((r) => aplica(r.data, "Captura guardada"))
      .catch((e) => err(e, "No se pudo guardar la captura"))
      .finally(() => setTrabajando(false));
  }

  function terminar() {
    Swal.fire({
      title: `Terminar la recepcion del folio ${rec.idRecepcion}`,
      html: `<div style="text-align:left;font-size:14px">Pasa a <b>Auditoria</b> y se le avisa por correo.
        <label style="display:block;margin-top:12px"><input type="checkbox" id="rc-parcial"> Es una <b>recepcion parcial</b>: el contenedor no llego completo y va a llegar mas</label>
        <div style="font-size:12px;color:#64748b;margin-top:6px">En una parcial lo que falta no cuenta como faltante y el embarque queda abierto con su saldo.</div></div>`,
      showCancelButton: true,
      confirmButtonText: "Terminar",
      cancelButtonText: "Cancelar",
      preConfirm: () => (document.getElementById("rc-parcial").checked ? "Si" : "No"),
    }).then((r) => {
      if (!r.isConfirmed) return;
      setTrabajando(true);
      axios
        .post(`${URL}Terminar/${rec._id}`, { parcial: r.value }, { headers })
        .then((res) => aplica(res.data, "Enviado a auditoria"))
        .catch((e) => err(e, "No se pudo terminar"))
        .finally(() => setTrabajando(false));
    });
  }

  function audita(resultado) {
    Swal.fire({
      title: resultado === "Conforme" ? "Dar conformidad" : "Registrar diferencias",
      input: "textarea",
      inputLabel: resultado === "Conforme" ? "Observaciones (opcional)" : "¿Que diferencias encontraste?",
      inputValidator: (v) => (resultado !== "Conforme" && !String(v || "").trim() ? "Escribe las diferencias" : undefined),
      showCancelButton: true,
      confirmButtonText: resultado === "Conforme" ? "Conforme" : "Regresar a Bodega",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      axios
        .patch(`${URL}Auditoria/${rec._id}`, { resultado, observaciones: r.value || "" }, { headers })
        .then((res) => aplica(res.data, resultado === "Conforme" ? "Auditoria conforme" : "Regresado a Bodega"))
        .catch((e) => err(e, "No se pudo guardar la auditoria"));
    });
  }

  function cerrar() {
    Swal.fire({
      title: `Cerrar el folio ${rec.idRecepcion}`,
      html: `<div style="text-align:left;font-size:14px">Se <b>libera el inventario</b>: cada tarima a su ubicacion en CEDIS y las danadas al almacen Calidad.
        ${rec.parcial === "Si" ? "<br>Es parcial: el embarque queda abierto con su saldo." : "<br>El embarque queda recibido."}
        <br>Sale el correo de <b>ARRIBOS</b> con copia al CFO.</div>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Cerrar y liberar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      setTrabajando(true);
      axios
        .post(`${URL}Cerrar/${rec._id}`, {}, { headers })
        .then((res) => {
          aplica(res.data, "Folio cerrado e inventario liberado");
          abre(res.data._id); // recarga con la entrada (Compra) ya ligada
        })
        .catch((e) => err(e, "No se pudo cerrar"))
        .finally(() => setTrabajando(false));
    });
  }

  function reenviar() {
    Swal.fire({ title: "¿Reenviar el correo de ARRIBOS?", showCancelButton: true, confirmButtonText: "Reenviar", cancelButtonText: "Cancelar" }).then((r) => {
      if (!r.isConfirmed) return;
      axios
        .post(`${URL}ReenviarArribos/${rec._id}`, {}, { headers })
        .then((res) => aplica(res.data, "ARRIBOS reenviado"))
        .catch((e) => err(e, "No se pudo reenviar"));
    });
  }

  // ---- tarimas ----
  function abreTarimas(r) {
    setRenglonTar(r);
    setPorTarima("");
    const falta = Number(r.recibidas || 0) - (r.tarimas || []).reduce((t, x) => t + Number(x.cantidad || 0), 0);
    setNuevasTar(falta > 0 ? [{ id: 1, cantidad: falta, ubicacion: "" }] : []);
  }
  const faltaEnTarimas = (r) => Number(r.recibidas || 0) - (r.tarimas || []).reduce((t, x) => t + Number(x.cantidad || 0), 0);

  function repartir() {
    const nPz = Math.floor(Number(porTarima) || 0);
    const falta = faltaEnTarimas(renglonTar);
    if (nPz <= 0 || falta <= 0) return;
    const cuantas = Math.ceil(falta / nPz);
    if (cuantas > 80) {
      Swal.fire({ icon: "warning", title: `Serian ${cuantas} tarimas` });
      return;
    }
    setNuevasTar(Array.from({ length: cuantas }, (_, i) => ({ id: i + 1, cantidad: Math.min(nPz, falta - i * nPz), ubicacion: "" })));
  }

  function guardaTarimas() {
    const tarimas = nuevasTar.filter((t) => Number(t.cantidad) > 0).map((t) => ({ cantidad: Number(t.cantidad), ubicacion: t.ubicacion || "Pendiente" }));
    if (!tarimas.length) return;
    axios
      .patch(`${URL}Tarimas/${rec._id}`, { renglon: renglonTar._id, tarimas }, { headers })
      .then((res) => {
        aplica(res.data);
        const nuevo = res.data.renglones.find((x) => x._id === renglonTar._id);
        setRenglonTar(nuevo);
        setNuevasTar([]);
      })
      .catch((e) => err(e, "No se pudieron guardar las tarimas"));
  }

  function quitaTarima(lpn) {
    axios
      .patch(`${URL}Tarimas/${rec._id}`, { renglon: renglonTar._id, quitarLpn: lpn }, { headers })
      .then((res) => {
        aplica(res.data);
        setRenglonTar(res.data.renglones.find((x) => x._id === renglonTar._id));
      })
      .catch((e) => err(e, "No se pudo quitar la tarima"));
  }

  // Etiquetas 4x3": LPN grande + QR + datos de la tarima
  async function etiquetas(soloRenglon) {
    const lista = [];
    rec.renglones
      .filter((r) => !soloRenglon || r._id === soloRenglon._id)
      .forEach((r) => (r.tarimas || []).forEach((t) => lista.push({ r, t })));
    if (!lista.length) {
      Swal.fire({ icon: "info", title: "Todavia no hay tarimas" });
      return;
    }
    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [102, 76] });
    for (let i = 0; i < lista.length; i++) {
      const { r, t } = lista[i];
      if (i) doc.addPage([102, 76], "landscape");
      const qr = await qrcode.toDataURL(t.lpn, 4);
      doc.addImage(qr, "png", 4, 14, 34, 34);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(20);
      doc.text(t.lpn, 4, 10);
      doc.setFontSize(12);
      doc.text(String(r.sku || ""), 42, 20);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(doc.splitTextToSize(String(r.nombre || ""), 56).slice(0, 3), 42, 25);
      doc.setFontSize(9);
      doc.text(`UPC: ${r.upc || "-"}`, 42, 38);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text(`${Number(t.cantidad).toLocaleString("en-US")} pzs`, 42, 46);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(`Folio ${rec.idRecepcion} · Cont. ${rec.contenedor} · Emb. ${rec.numeroEmbarque}`, 4, 56);
      doc.text(`Ubicacion: ${t.ubicacion} · ${t.fecha}`, 4, 61);
      doc.text(`Tarima ${i + 1} de ${lista.length}`, 4, 66);
    }
    doc.save(`Etiquetas_Folio_${rec.idRecepcion}${soloRenglon ? `_${soloRenglon.sku}` : ""}.pdf`);
  }

  function buscaLpn() {
    const lpn = lpnBuscar.trim().toUpperCase();
    if (!lpn) return;
    axios
      .get(`${URL}Lpn/${encodeURIComponent(lpn)}`, { headers })
      .then((r) => {
        const d = r.data;
        Swal.fire({
          title: d.lpn,
          html: `<div style="text-align:left;font-size:14px"><b>${d.sku}</b> · ${d.nombre}<br>${Number(d.cantidad).toLocaleString("en-US")} pzs · ubicacion <b>${d.ubicacion}</b><br>Folio ${d.folio} (${d.estado}) · contenedor ${d.contenedor} · ${d.fecha}</div>`,
        });
      })
      .catch((e) => err(e, "No se encontro"));
  }

  if (!(user.recepciones || user.recepciones_auditar || user.embarques)) {
    return (
      <>
        <Header />
        <div className="card" style={{ margin: 20, padding: 20 }}>
          No tienes permiso para ver las recepciones.
        </div>
      </>
    );
  }

  const totales = rec
    ? rec.renglones.reduce(
        (t, r) => ({
          esperado: t.esperado + Number(r.esperado || 0),
          recibidas: t.recibidas + Number(r.recibidas || 0),
          danadas: t.danadas + Number(r.danadas || 0),
          tarimas: t.tarimas + (r.tarimas || []).length,
        }),
        { esperado: 0, recibidas: 0, danadas: 0, tarimas: 0 }
      )
    : null;

  return (
    <>
      <Header />
      <br />
      <div className="card col-12">
        <Row style={{ marginTop: 8 }}>
          <Col md={6}>
            {rec ? (
              <Button size="sm" color="secondary" title="Regresar al listado de folios" onClick={() => setRec(null)}>
                <i class="fas fa-arrow-left"></i> Folios
              </Button>
            ) : (
              <Button size="sm" href="/MenuCompras" className="btn btn-danger">
                Regresar
              </Button>
            )}{" "}
            {!rec && user.recepciones ? (
              <Button size="sm" color="success" title="Abrir un folio de recepcion para un contenedor" onClick={nueva}>
                <i class="fas fa-truck-loading"></i> Nueva recepcion
              </Button>
            ) : null}
          </Col>
          <Col md={6} style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
            <Input
              bsSize="sm"
              placeholder="Escanea o escribe un LPN"
              value={lpnBuscar}
              onChange={(e) => setLpnBuscar(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && buscaLpn()}
              style={{ maxWidth: 220 }}
            />
            <Button size="sm" color="info" title="Buscar la tarima por su LPN" onClick={buscaLpn}>
              <i class="fas fa-qrcode"></i>
            </Button>
          </Col>
        </Row>

        {!rec ? (
          <>
            <h3 align="center">Recepcion de contenedores</h3>
            <Row style={{ marginBottom: 8 }}>
              <Col md={3}>
                <Input bsSize="sm" type="select" value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                  <option value="">Todos los estados</option>
                  {Object.keys(COLOR_ESTADO).map((x) => (
                    <option key={x} value={x}>
                      {x}
                    </option>
                  ))}
                </Input>
              </Col>
            </Row>
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th>Folio</th>
                  <th>Contenedor</th>
                  <th>Embarque</th>
                  <th>Proveedor</th>
                  <th>Abierto</th>
                  <th className="text-right">Piezas</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {folios.map((f) => (
                  <tr key={f._id}>
                    <td>
                      <b>{f.idRecepcion}</b>
                    </td>
                    <td>{f.contenedor}</td>
                    <td>{f.numeroEmbarque}</td>
                    <td style={{ fontSize: 12 }}>{f.proveedores && f.proveedores.nombre_comercial}</td>
                    <td style={{ fontSize: 12 }}>
                      {f.fecha} · {f.abrio}
                    </td>
                    <td className="text-right">
                      {f.renglones.reduce((t, r) => t + Number(r.recibidas || 0) + Number(r.danadas || 0), 0).toLocaleString("en-US")}
                    </td>
                    <td>
                      <Badge color={COLOR_ESTADO[f.estado] || "secondary"} pill>
                        {f.estado}
                      </Badge>
                      {f.parcial === "Si" ? (
                        <Badge color="light" pill style={{ marginLeft: 4 }}>
                          Parcial
                        </Badge>
                      ) : null}
                    </td>
                    <td>
                      <Button size="sm" color="primary" title="Abrir el folio" onClick={() => abre(f._id)}>
                        <i class="fas fa-folder-open"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
                {!folios.length ? (
                  <tr>
                    <td colSpan={8} style={{ color: "#94a3b8" }}>
                      No hay folios
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </Table>
          </>
        ) : (
          <>
            <h3 align="center" style={{ marginBottom: 2 }}>
              Folio {rec.idRecepcion} · {rec.contenedor}
            </h3>
            <div style={{ textAlign: "center", fontSize: 13, color: "#64748b", marginBottom: 10 }}>
              Embarque {rec.numeroEmbarque} · {rec.proveedores && rec.proveedores.nombre_comercial} · abierto {rec.fecha} por {rec.abrio}
              {rec.fechaRecibo ? ` · recibido desde ${rec.fechaRecibo}` : ""}{" "}
              <Badge color={COLOR_ESTADO[rec.estado] || "secondary"} pill>
                {rec.estado}
              </Badge>
              {rec.parcial === "Si" ? (
                <Badge color="dark" pill style={{ marginLeft: 4 }} title="El contenedor no llego completo; el embarque queda abierto con su saldo">
                  Parcial
                </Badge>
              ) : null}
            </div>
            {rec.estado === "Con diferencias" ? (
              <div style={{ background: "#fef2f2", color: "#991b1b", padding: "6px 10px", borderRadius: 6, fontSize: 13, marginBottom: 8 }}>
                <b>Auditoria encontro diferencias:</b> {rec.auditoria && rec.auditoria.observaciones}. Corrige con una captura (+/-) o en las tarimas y
                vuelve a mandarla a auditoria.
              </div>
            ) : null}

            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Articulo</th>
                  <th>UPC</th>
                  <th className="text-right">Esperado</th>
                  <th className="text-right">Buenas</th>
                  <th className="text-right">Danadas</th>
                  {puedeCapturar ? <th style={{ width: 170 }}>Capturar ahora (+/-)</th> : null}
                  <th>Tarimas</th>
                  {rec.estado !== "Abierta" ? <th className="text-right">Faltan / Sobran</th> : null}
                </tr>
              </thead>
              <tbody>
                {rec.renglones.map((r) => {
                  const falta = faltaEnTarimas(r);
                  return (
                    <tr key={r._id}>
                      <td>
                        <b>{r.sku}</b>
                      </td>
                      <td style={{ fontSize: 12 }}>{r.nombre}</td>
                      <td style={{ fontSize: 12 }}>{r.upc}</td>
                      <td className="text-right">{Number(r.esperado).toLocaleString("en-US")}</td>
                      <td className="text-right">
                        <b>{Number(r.recibidas).toLocaleString("en-US")}</b>
                      </td>
                      <td className="text-right" style={{ color: r.danadas ? "#b91c1c" : undefined }}>
                        {r.danadas}
                      </td>
                      {puedeCapturar ? (
                        <td>
                          <div style={{ display: "flex", gap: 4 }}>
                            <Input
                              bsSize="sm"
                              type="number"
                              placeholder="Buenas"
                              title="Piezas buenas de esta captura (negativo para corregir)"
                              value={(captura[r._id] && captura[r._id].recibidas) || ""}
                              onChange={(e) => setCaptura({ ...captura, [r._id]: { ...(captura[r._id] || {}), recibidas: e.target.value } })}
                            />
                            <Input
                              bsSize="sm"
                              type="number"
                              placeholder="Danadas"
                              title="Piezas danadas de esta captura"
                              value={(captura[r._id] && captura[r._id].danadas) || ""}
                              onChange={(e) => setCaptura({ ...captura, [r._id]: { ...(captura[r._id] || {}), danadas: e.target.value } })}
                            />
                          </div>
                        </td>
                      ) : null}
                      <td style={{ whiteSpace: "nowrap" }}>
                        <Button
                          size="sm"
                          color={falta === 0 && r.recibidas ? "success" : "secondary"}
                          outline={!(falta === 0 && r.recibidas)}
                          title="Ver y armar las tarimas (LPN) de este articulo"
                          onClick={() => abreTarimas(r)}
                        >
                          <i class="fas fa-pallet"></i> {(r.tarimas || []).length}
                        </Button>
                        {falta > 0 ? <span style={{ fontSize: 11, color: "#b45309", marginLeft: 4 }}>faltan {falta} pzs en tarimas</span> : null}
                      </td>
                      {rec.estado !== "Abierta" ? (
                        <td className="text-right" style={{ fontSize: 12 }}>
                          {r.faltantes ? <span style={{ color: "#b91c1c" }}>-{r.faltantes}</span> : null}
                          {r.excedentes ? <span style={{ color: "#1d4ed8", marginLeft: 4 }}>+{r.excedentes}</span> : null}
                          {!r.faltantes && !r.excedentes ? "—" : null}
                        </td>
                      ) : null}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={3} style={{ fontWeight: 600 }}>
                    Total
                  </td>
                  <td className="text-right" style={{ fontWeight: 600 }}>
                    {totales.esperado.toLocaleString("en-US")}
                  </td>
                  <td className="text-right" style={{ fontWeight: 600 }}>
                    {totales.recibidas.toLocaleString("en-US")}
                  </td>
                  <td className="text-right" style={{ fontWeight: 600 }}>
                    {totales.danadas}
                  </td>
                  {puedeCapturar ? <td></td> : null}
                  <td style={{ fontWeight: 600 }}>{totales.tarimas} tarimas</td>
                  {rec.estado !== "Abierta" ? <td></td> : null}
                </tr>
              </tfoot>
            </Table>

            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
              {puedeCapturar ? (
                <>
                  <Button color="primary" disabled={trabajando} title="Sumar esta captura al folio" onClick={guardaCaptura}>
                    <i class="fas fa-save"></i> Guardar captura
                  </Button>
                  <Button color="warning" disabled={trabajando} title="Termina la recepcion y la pasa a Auditoria" onClick={terminar}>
                    <i class="fas fa-flag-checkered"></i> {rec.estado === "Con diferencias" ? "Volver a mandar a auditoria" : "Terminar recepcion"}
                  </Button>
                </>
              ) : null}
              {rec.estado === "En auditoria" && user.recepciones_auditar ? (
                <>
                  <Button color="success" title="La recepcion esta bien: ya se puede cerrar" onClick={() => audita("Conforme")}>
                    <i class="fas fa-check-double"></i> Conforme
                  </Button>
                  <Button color="danger" title="Hay diferencias: regresa a Bodega y avisa a Importaciones" onClick={() => audita("Con diferencias")}>
                    <i class="fas fa-exclamation-triangle"></i> Con diferencias
                  </Button>
                </>
              ) : null}
              {rec.estado === "Auditada" && user.recepciones ? (
                <Button color="success" disabled={trabajando} title="Libera el inventario y manda ARRIBOS" onClick={cerrar}>
                  <i class="fas fa-lock"></i> Cerrar folio y liberar inventario
                </Button>
              ) : null}
              <Button color="secondary" outline title="Etiquetas con QR de todas las tarimas" onClick={() => etiquetas(null)}>
                <i class="fas fa-print"></i> Etiquetas
              </Button>
              {rec.estado === "Cerrada" && (user.recepciones_auditar || user.usuarios_permisos) ? (
                <Button color="secondary" outline title="Reenvio autorizado del correo de ARRIBOS" onClick={reenviar}>
                  <i class="fas fa-paper-plane"></i> Reenviar ARRIBOS
                </Button>
              ) : null}
            </div>

            <Row style={{ fontSize: 12, color: "#475569" }}>
              <Col md={4}>
                <b>Capturas</b>
                {rec.renglones
                  .flatMap((r) => (r.capturas || []).map((c) => ({ ...c, sku: r.sku })))
                  .map((c, i) => (
                    <div key={i}>
                      {c.fecha} {c.hora} · {c.user} · {c.sku}: {c.recibidas} buenas{c.danadas ? `, ${c.danadas} danadas` : ""}
                      {c.observaciones ? ` (${c.observaciones})` : ""}
                    </div>
                  ))}
              </Col>
              <Col md={4}>
                <b>Auditoria</b>
                {(rec.historialAuditoria || []).map((h, i) => (
                  <div key={i}>
                    {h.fecha} · {h.por}: <b>{h.resultado}</b>
                    {h.observaciones ? ` — ${h.observaciones}` : ""}
                  </div>
                ))}
                {!(rec.historialAuditoria || []).length ? <div>—</div> : null}
              </Col>
              <Col md={4}>
                <b>Cierre y ARRIBOS</b>
                {rec.fechaCierre ? (
                  <div>
                    Cerrado {rec.fechaCierre} {rec.horaCierre} por {rec.cerradaPor}
                    {rec.compras && rec.compras.idCompras ? ` · entrada ${rec.compras.idCompras}` : ""}
                  </div>
                ) : (
                  <div>—</div>
                )}
                {rec.arribos && rec.arribos.enviado === "Si" ? (
                  <div>
                    Correo {rec.arribos.estado} · {rec.arribos.fecha} {rec.arribos.hora} · para {(rec.arribos.para || []).join(", ")}
                    {(rec.arribos.reenvios || []).map((x, i) => (
                      <div key={i}>
                        Reenvio {x.fecha} {x.hora} · {x.por} · {x.estado}
                      </div>
                    ))}
                  </div>
                ) : null}
              </Col>
            </Row>
            <br />
          </>
        )}
      </div>

      <Modal isOpen={modalNueva} toggle={() => setModalNueva(false)}>
        <ModalHeader toggle={() => setModalNueva(false)}>Nueva recepcion</ModalHeader>
        <ModalBody>
          <Label>Embarque que llego</Label>
          <Input type="select" value={embElegido} onChange={(e) => setEmbElegido(e.target.value)}>
            <option value="">Elige...</option>
            {embarques.map((e) => (
              <option key={e._id} value={e._id}>
                Emb. {e.idEmbarques} · {e.contenedor} · {e.proveedor}
                {e.fechaLlegada ? ` · llega ${e.fechaLlegada}` : ""}
                {e.packingListRecibido === "Si" ? "" : " · sin packing list"}
              </option>
            ))}
          </Input>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 6 }}>
            Solo salen embarques no recibidos y sin otro folio abierto. El folio toma lo que falta por recibir de cada articulo.
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" disabled={!embElegido || trabajando} onClick={creaFolio}>
            Abrir folio
          </Button>
          <Button color="secondary" onClick={() => setModalNueva(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={!!renglonTar} toggle={() => setRenglonTar(null)}>
        <ModalHeader toggle={() => setRenglonTar(null)}>
          Tarimas · {renglonTar && renglonTar.sku}
        </ModalHeader>
        <ModalBody>
          {renglonTar ? (
            <>
              <div style={{ fontSize: 13, color: "#475569", marginBottom: 8 }}>
                {renglonTar.nombre} · {Number(renglonTar.recibidas).toLocaleString("en-US")} piezas buenas ·{" "}
                <b style={{ color: faltaEnTarimas(renglonTar) ? "#b45309" : "#15803d" }}>
                  {faltaEnTarimas(renglonTar) ? `faltan ${faltaEnTarimas(renglonTar)} en tarimas` : "todas en tarimas"}
                </b>
              </div>
              <Table size="sm" borderless striped>
                <thead>
                  <tr>
                    <th>LPN</th>
                    <th className="text-right">Piezas</th>
                    <th>Ubicacion</th>
                    <th>Fecha</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(renglonTar.tarimas || []).map((t) => (
                    <tr key={t.lpn}>
                      <td>
                        <b>{t.lpn}</b>
                      </td>
                      <td className="text-right">{t.cantidad}</td>
                      <td>{t.ubicacion}</td>
                      <td style={{ fontSize: 12 }}>
                        {t.fecha} · {t.user}
                      </td>
                      <td>
                        {puedeCapturar ? (
                          <Button size="sm" color="danger" title="Quitar esta tarima" onClick={() => quitaTarima(t.lpn)}>
                            <i class="fas fa-trash"></i>
                          </Button>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {puedeCapturar && faltaEnTarimas(renglonTar) > 0 ? (
                <>
                  <hr />
                  <Row className="align-items-end">
                    <Col md={4}>
                      <Label style={{ fontSize: 12 }}>Piezas por tarima</Label>
                      <Input bsSize="sm" type="number" value={porTarima} onChange={(e) => setPorTarima(e.target.value)} placeholder="Ej. 120" />
                    </Col>
                    <Col md={4}>
                      <Button size="sm" color="info" title="Arma las tarimas que faltan con esas piezas cada una" onClick={repartir}>
                        <i class="fas fa-layer-group"></i> Repartir
                      </Button>
                    </Col>
                  </Row>
                  <div style={{ fontSize: 12, color: "#64748b", margin: "6px 0" }}>
                    La ubicacion es opcional: si la dejas vacia la tarima queda en Pendiente para acomodarla despues.
                  </div>
                  {nuevasTar.map((t, i) => (
                    <Row key={t.id} style={{ marginBottom: 4 }}>
                      <Col md={1} style={{ fontSize: 12, paddingTop: 6 }}>
                        {i + 1}
                      </Col>
                      <Col md={4}>
                        <Input
                          bsSize="sm"
                          type="number"
                          value={t.cantidad}
                          onChange={(e) => setNuevasTar(nuevasTar.map((x) => (x.id === t.id ? { ...x, cantidad: e.target.value } : x)))}
                        />
                      </Col>
                      <Col md={5}>
                        <Input
                          bsSize="sm"
                          placeholder="Ubicacion (opcional)"
                          value={t.ubicacion}
                          onChange={(e) => setNuevasTar(nuevasTar.map((x) => (x.id === t.id ? { ...x, ubicacion: e.target.value.toUpperCase() } : x)))}
                        />
                      </Col>
                      <Col md={2}>
                        <Button size="sm" color="danger" outline title="Quitar" onClick={() => setNuevasTar(nuevasTar.filter((x) => x.id !== t.id))}>
                          <i class="fas fa-times"></i>
                        </Button>
                      </Col>
                    </Row>
                  ))}
                  <Button
                    size="sm"
                    color="secondary"
                    outline
                    title="Otra tarima"
                    onClick={() => setNuevasTar([...nuevasTar, { id: Date.now(), cantidad: "", ubicacion: "" }])}
                  >
                    <i class="fas fa-plus"></i> Tarima
                  </Button>
                </>
              ) : null}
            </>
          ) : null}
        </ModalBody>
        <ModalFooter>
          {puedeCapturar && nuevasTar.length ? (
            <Button color="success" title="Guardar las tarimas y generar sus LPN" onClick={guardaTarimas}>
              Guardar tarimas
            </Button>
          ) : null}
          {renglonTar && (renglonTar.tarimas || []).length ? (
            <Button color="secondary" outline title="Etiquetas con QR de este articulo" onClick={() => etiquetas(renglonTar)}>
              <i class="fas fa-print"></i> Etiquetas
            </Button>
          ) : null}
          <Button color="secondary" onClick={() => setRenglonTar(null)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Recepciones;
